<!--
  线上充值
  lovi 2020-1-10
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="payType == 5 ? $t('common.weChatPay') : ''"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <scroll>
        <div class="pay-wrap">
          <h3>{{ routeData.money }}</h3>
          <div class="code-wrap">
            <img
              v-if="routeData.return_charge"
              :src="routeData.return_charge.code_url"
            />
          </div>
          <p>
            {{ $t("common.pleaseUse") }}
            {{ payType == 5 ? $t("common.weChat") : "" }}
            {{ $t("common.scanPay") }}
          </p>
        </div>
        <div class="button-wrap">
          <van-button block type="primary" @click="_getDetails">
            {{ $t("common.confirmPayment") }}
          </van-button>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "payCode",
  components: {},
  data() {
    return {
      flag: 0, //1充值、2提现、3转账、5话费、6流量、20账单
      order: "", // 是否订单详情
      payType: 0, // 5.微信
      routeData: {} // 路由数据
    };
  },
  created() {
    let vm = this;
    vm.payType = vm.$route.query.payType;
    vm.flag = vm.$route.query.flag;
    vm.order = vm.$route.query.order || "";
    if (_.isEmpty(vm.$route.params)) {
      // 刷新页面要返回
      vm._back();
    } else {
      vm.routeData = vm.$route.params;
    }
    console.log("routeData", vm.routeData);
  },
  mounted() {},
  computed: {},
  methods: {
    _getDetails() {
      // 详情
      let vm = this;
      if (vm.order) {
        vm.$router.replace({
          // 订单详情
          path: "/orderDetail",
          name: "orderDetail",
          query: { id: vm.routeData.order_id }
        });
      } else {
        vm.$router.replace({
          path: "/detail",
          name: "detail",
          query: { flag: vm.flag, order_id: vm.routeData.order_id },
          params: vm.routeData
        });
      }
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.pay-wrap {
  padding-top: 20px;
  text-align: center;
  h3 {
    color: #2042ab;
    font-size: 28px;
    font-weight: 500;
    line-height: 1.5;
  }
  .code-wrap {
    padding: 20px 0;
    img {
      width: 180px;
      height: 180px;
    }
  }
  p {
    font-size: 16px;
  }
}
</style>
